/*************************************************/
/* Slider                                        */
/*************************************************/
import Swiper from "swiper";
import { Pagination } from 'swiper/modules';
import { Navigation } from "swiper/modules";
Swiper.use([Pagination, Navigation]);
export function slider() {
    const cardsSliderSelector = ".cards-slider__inner.swiper";
    const contentSliderSelector = ".content-slider__inner.swiper";
    const coursesSliderSelector = ".courses__courses.swiper";
    const contentBoxesSliderSelector = ".content-boxes__boxes--mobile.swiper";
    const quoteSliderSelector = ".quote-slider__inner.swiper";
    const gallerySliderSelector = ".gallery__inner.swiper";
    const relatedSubjectsSliderSelector = ".related-subjects__inner.swiper";

    //Fix the tabindex for accebility if the content of the slide is wrapped in an anchor tag
    const handleSlideChangeTransitionEnd = function (swiper) {
        swiper.el
            .querySelectorAll(" .swiper-slide > a")
            .forEach((slide) => {
                slide.setAttribute("tabindex", "-1");
            });

        const activeSlide = swiper.el.querySelector(" .swiper-slide-active > a"
        );
        if (activeSlide != null) {
            activeSlide.setAttribute("tabindex", "0");
        }
    };

    //Makes sure that the lazyloaded image on the duplicate slide has the right class so it doesnt show up as grey
    const handleSlideChange = function () {
        var nextDuplicateSlide = document.querySelector(".swiper-slide-duplicate.swiper-slide-next");
        if (nextDuplicateSlide != null) {
            var unloadedSlideImage = nextDuplicateSlide.querySelector("img.lazyloading");
            if (unloadedSlideImage != null) {
                unloadedSlideImage.classList.replace("lazyloading", "lazyloaded");
            }
        }
    }

    const init = function () {

        const cardsSlider = [];
        const cardsSliderElements = document.querySelectorAll(cardsSliderSelector);
        if (cardsSliderElements) {
            cardsSliderElements.forEach((slider) => {
                cardsSlider.push(new Swiper(slider, {
                    slidesPerView: 1.1,
                    spaceBetween: 15,
                    loop: true,
                    slidesOffsetAfter: 15,
                    breakpoints: {
                        // when window width is >= 768px
                        992: {
                            slidesPerView: "auto",
                            spaceBetween: 30,
                            slidesOffsetAfter: 45,
                        },
                    },
                    pagination: {
                        el: '#' + slider.dataset.componentId + " .swiper-pagination",
                        clickable: true,
                    },
                    // Navigation arrows
                    navigation: {
                        nextEl: '#' + slider.dataset.componentId + ' .swiper-button-next',
                        prevEl: '#' + slider.dataset.componentId + ' .swiper-button-prev'
                    },

                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);
                        }
                    }
                }));
            })
        }        
        
        const contentSlider = [];
        const contentSliderElements = document.querySelectorAll(contentSliderSelector);
        if (contentSliderElements) {
            contentSliderElements.forEach((slider) => {
                contentSlider.push(new Swiper(slider, {
                    slidesPerView: 1.1,
                    spaceBetween: 15,
                    loop: true,
                    slidesOffsetAfter: 15,
                    breakpoints: {
                        // when window width is >= 768px
                        992: {
                            slidesPerView: "auto",
                            spaceBetween: 30,
                            slidesOffsetAfter: 45,
                        },
                    },
                    pagination: {
                        el: '#' + slider.dataset.componentId + " .swiper-pagination",
                        clickable: true,
                    },

                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);
                        }
                    }
                }));
            })
        }

        // Content Boxes Slider
        const ContentBoxesSlider = [];
        const ContentBoxesSliderElements = document.querySelectorAll(contentBoxesSliderSelector);
        if (ContentBoxesSliderElements) {
            ContentBoxesSliderElements.forEach(slider => {
                ContentBoxesSlider.push(new Swiper(slider, {
                    loop: false,
                    slidesPerView: 1.4,
                    spaceBetween: 15,
                    slidesOffsetAfter:15,
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);
                        }
                    }
                }));
            })
        }

        const quoteSlider = [];
        const quoteSliderElements = document.querySelectorAll(quoteSliderSelector);
        if (quoteSliderElements) {
            quoteSliderElements.forEach((slider) => {
                quoteSlider.push(new Swiper(slider, {
                    slidesPerView: 1.1,
                    spaceBetween: 15,
                    loop: true,
                    slidesOffsetAfter: 15,
                    breakpoints: {
                        // when window width is >= 768px
                        992: {
                            slidesPerView: "auto",
                            spaceBetween: 30,
                            slidesOffsetAfter: 45,
                        },
                    },
                    pagination: {
                        el: '#' + slider.dataset.componentId + " .swiper-pagination",
                        clickable: true,
                    },

                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);
                        }
                    }
                }));
            })
        }

        const coursesSlider = [];
        const coursesSliderElements = document.querySelectorAll(coursesSliderSelector);
        if (coursesSliderElements) {
            coursesSliderElements.forEach((slider) => {
                coursesSlider.push(new Swiper(slider, {
                    slidesPerView: 1.1,
                    spaceBetween: 15,
                    slidesOffsetAfter: 15,
                    breakpoints: {
                        // when window width is >= 768px
                        992: {
                            slidesPerView: 3,
                            spaceBetween: 30,
                            slidesOffsetAfter: 45,
                        },
                    },
                    pagination: {
                        el: '#' + slider.dataset.componentId + " .swiper-pagination",
                        clickable: true,
                    },

                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);
                        }
                    }
                }));
            })
        }

        const gallerySlider = [];
        const gallerySliderElements = document.querySelectorAll(gallerySliderSelector);
        if (gallerySliderElements) {
            gallerySliderElements.forEach((slider) => {
                const windowWidth = window.innerWidth;
                if (windowWidth < 992) {
                    gallerySlider.push(new Swiper(slider, {
                        slidesPerView: 1.1,
                        spaceBetween: 15,
                        pagination: {
                            el: '#' + slider.dataset.componentId + " .swiper-pagination",
                            clickable: true,
                        },

                        on: {
                            slideChange: () => {
                                handleSlideChange();
                            },
                            slideChangeTransitionEnd: (swiper) => {
                                handleSlideChangeTransitionEnd(swiper);
                            }
                        }
                    }));
                }
            })
        } 
        
        const relatedSubjectsSlider = [];
        const relatedSubjectsSliderElements = document.querySelectorAll(relatedSubjectsSliderSelector);
        if (relatedSubjectsSliderElements) {
            relatedSubjectsSliderElements.forEach((slider) => {
                const windowWidth = window.innerWidth;
                if (windowWidth < 992) {
                    relatedSubjectsSlider.push(new Swiper(slider, {
                        slidesPerView: 1.1,
                        spaceBetween: 15,
                        on: {
                            slideChange: () => {
                                handleSlideChange();
                            },
                            slideChangeTransitionEnd: (swiper) => {
                                handleSlideChangeTransitionEnd(swiper);
                            }
                        }
                    }));
                }
            })
        }
    };

    init();
}
